import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Select from 'react-select';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import { setRows, addRow, removeRow, removeSingleRow, updateRow, clearRows } from '../../../Redux/actions/rowActions';
import { IoAddSharp } from "react-icons/io5";
import { RxCross1 } from "react-icons/rx";
import AsyncSelect from 'react-select/async';
import Tooltip from './tooltip';
import { PO_ITEM_COL, poCompactSelectStyles, } from '../purchaseOrder/poItemGridColumns';

const RequisitionGrid = ({ onRequisitionData, itemData, formData, selectedLocation, precision, itemtype, ReqNo }) => {
    const rows = useSelector(state => state.rows.rows);
    const dispatch = useDispatch();
    const [itemOptions, setItemOptions] = useState([]);
    const [itemRows, setItemRows] = useState([]);
    const [descriptionOptions, setDescriptionOptions] = useState([]);
    const apiService = new ApiService();
    const initialMount = useRef(true);
    const [page, setPage] = useState(1);
    const [desPage, setDecPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loader, setLoaders] = useState(false);

    useEffect(() => {
        const getItems = async () => {
            try {

                if (initialMount.current && itemData?.prDetails && itemData.prDetails.length > 0) {
                    const formattedRowsitm = itemData?.prDetails.map(async (detail, index) => {
                        const selecteditms = await apiService.getApiParamater("GET_ITEM", `?ItemNo=${detail.itemCode}`);
                        let selecteditem = selecteditms?.data?.result[0]

                        return {
                            requisitionNo: ReqNo,
                            srno: detail.srno,
                            itemNo: detail.itemCode,
                            recordId: detail.itemCode,
                            itemDescription: detail.itemDescription,
                            branch: '',
                            qty: detail.qty,
                            uom: detail.uom,
                            baseQty: selecteditem.convToInvUOM * detail.qty,
                            convRate: selecteditem.convToInvUOM,
                            baseAmount: detail?.unitPrice?.toFixed(precision || 3) || 0,
                            specification: detail.specification,
                            amount: detail?.amount?.toFixed(precision || 3),
                            stock: (selecteditem?.stock / selecteditem.convToInvUOM)?.toFixed(2),
                            bol: ''
                        };
                    }).filter(row => row !== null);
                    const formattedRows = await Promise.all(formattedRowsitm);
                    if (formattedRows.length > 0) {
                        dispatch(setRows(formattedRows));
                        setItemRows(formattedRows);
                        onRequisitionData(formattedRows);
                    }
                } else if (itemData?.prDetails && formData?.copyRequest?.label) {
                    const formattedRowsitm = itemData?.prDetails.map(async (detail, index) => {
                        const selecteditms = await apiService.getApiParamater("GET_ITEM", `?ItemNo=${detail.itemCode}`);
                        let selecteditem = selecteditms?.data?.result[0]

                        return {
                            requisitionNo: ReqNo,
                            srno: detail.srno,
                            itemNo: detail.itemCode,
                            recordId: detail.itemCode,
                            itemDescription: detail.itemDescription,
                            branch: '',
                            qty: detail.qty,
                            uom: detail.uom,
                            baseQty: selecteditem.convToInvUOM * detail.qty,
                            convRate: selecteditem.convToInvUOM,
                            baseAmount: detail?.unitPrice?.toFixed(precision || 3) || 0,
                            specification: detail.specification,
                            amount: detail?.amount?.toFixed(precision || 3),
                            stock: (selecteditem?.stock / selecteditem.convToInvUOM)?.toFixed(2),
                            bol: ''
                        };
                    }).filter(row => row !== null);
                    const formattedRows = await Promise.all(formattedRowsitm);
                    if (formattedRows.length > 0) {
                        dispatch(setRows(formattedRows));
                        setItemRows(formattedRows);
                        onRequisitionData(formattedRows);
                    }
                }
            } catch (error) {
                console.error('Error fetching items:', error);
            }
        };
        if (itemData) {
            getItems();
        }
    }, [itemData, dispatch]);
    useEffect(() => {
        if (initialMount.current) {
            initialMount.current = false;
        } else {
            itemRows.forEach((row, index) => {
                dispatch(updateRow(index, row));
            });
        }
    }, [itemRows, dispatch]);
    useEffect(() => {
        onRequisitionData(rows);
    }, [rows]);

    useEffect(() => {
        fetchItemNo("", 1);
        fetchItemDesc("", 1);
    }, [itemtype]);

    useEffect(() => {
        if (rows[0]?.itemNo && selectedLocation?.label) {
            updateRowsWithNewStock();
        }
    }, [selectedLocation]);

    const fetchItemNo = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoaders(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('ItemNo', itemtype?.value || "");
            params.append('SearchTerm', inputValue || '');
            const response = await apiService.getApiParamater('GET_ITEM_DROPDOWN', `?${params.toString()}`);
            const fetchedItems = response.data.result.map(item => ({
                label: item.itemNo,
                value: item,
            }));
            if (fetchedItems.length < 20) setHasMore(false);
            if (itemtype?.value) {
                setItemOptions(fetchedItems);
            } else {
                setItemOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            }
            setLoaders(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoaders(false);
            return [];
        }
    };
    const fetchItemDesc = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoaders(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('SearchTerm', inputValue || '');
            params.append('ItemNo', itemtype?.value || "");

            const response = await apiService.getApiParamater('GET_ITEM_DROPDOWN', `?${params.toString()}`);

            const fetchedItems = response.data.result.map(item => ({
                label: item.itemDescription,
                value: item,
            }));
            if (fetchedItems.length < 20) setHasMore(false);
            if (itemtype?.value) {
                setDescriptionOptions(fetchedItems);
            } else {
                setDescriptionOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            }
            setLoaders(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoaders(false);
            return [];
        }
    };
    const loadOptions = async (inputValue, callback) => {
        if (inputValue?.trim().length < 3) {
            callback([]);
            return;
        }

        const options = await fetchItemNo(inputValue, 1);
        callback(options);
    };
    const loadDescOptions = async (inputValue, callback) => {
        if (inputValue?.trim().length < 3) {
            callback([]);
            return;
        }

        const options = await fetchItemDesc(inputValue, 1);
        callback(options);
    };
    const loadMoreOptions = async (inputValue = "") => {
        if (inputValue?.trim().length < 3 || !hasMore || loader) return;

        setPage(prevPage => prevPage + 1);
        await fetchItemNo(inputValue, page + 1);
    };
    const loadMoreDescOptions = async (inputValue = "") => {
        if (inputValue.length < 3 || !hasMore || loader) return;

        setDecPage(prevPage => prevPage + 1);
        await fetchItemDesc(inputValue, desPage + 1);
    };
    const handleInputChange = async (index, fieldName, value) => {
        const isDuplicate = rows.some((row, rowIndex) => rowIndex !== index && (row.itemNo === value || row.itemDescription === value));
        try {

            if (selectedLocation.length === 0) {
                toast.warning("Select Location")
                return;
            }
            const updatedRows = [...rows];
            const updatedRow = { ...updatedRows[index], [fieldName]: value, srno: ("0" + (index + 1)).slice(-2) };
            debugger
            if (fieldName === 'itemNo' || fieldName === 'itemDescription') {
                const encodedValue = encodeURIComponent(value);

                const queryParam =
                    fieldName === 'itemNo'
                        ? `itemNo=${encodedValue}`
                        : `itemDescription=${encodedValue}`;

                const selecteditmstock = await apiService.getApiParamater(
                    'GET_ITEM',
                    `?isActive=true&Warehouse=${encodeURIComponent(selectedLocation.label)}&${queryParam}`
                );
                debugger
                const selectedItem = selecteditmstock?.data?.result.find((row, rowIndex) => (row.itemNo === value || row.itemDescription === value));
                debugger
                // let selectedItem = selecteditmstock?.data?.result?.[0]

                if (selectedItem) {
                    updatedRow.itemDescription = selectedItem.itemDescription || "";
                    updatedRow.requisitionNo = ReqNo;
                    updatedRow.uom = selectedItem.baseUnit || "";
                    updatedRow.itemNo = selectedItem.itemNo || "";
                    updatedRow.specification = selectedItem.specification || "";
                    updatedRow.convRate = selectedItem.convToInvUOM || "";
                    updatedRow.baseQty = 0 || "";
                    updatedRow.stock = (selectedItem?.stock / selectedItem.convToInvUOM).toFixed(2) || 0;
                    updatedRow.supplierId = selectedItem?.supplier || "";
                    updatedRow.baseAmount = (0).toFixed(precision || 3)

                    fetchItemNo("", 1);
                    fetchItemDesc("", 1);
                }
            }
            if (fieldName === 'qty') {
                const quantity = parseFloat(value);
                const convToInvUOM = updatedRow.convRate;
                if (quantity < 0) {
                    toast.warning("Enter Quantity greater then 0")
                    return
                } else {
                    const baseQty = convToInvUOM ? parseFloat(convToInvUOM) : 1;
                    updatedRow.baseQty = (!isNaN(quantity) && quantity !== 0) ? (quantity * baseQty) : 0;
                }
            }
            if (fieldName === 'qty' || fieldName === 'baseAmount') {
                const unitPrice = parseFloat(updatedRow?.baseAmount);
                if (unitPrice < 0) {
                    toast.warning("Enter Unit Price greater then 0")
                    return
                } else {
                    const quantity = parseFloat(updatedRow.qty);
                    updatedRow.amount = (!isNaN(quantity) && !isNaN(unitPrice)) ? (unitPrice * quantity).toFixed(precision || 3) : 0;
                }
            }
            updatedRows[index] = updatedRow;
            dispatch(setRows(updatedRows));
            setItemRows(updatedRows);
            onRequisitionData(updatedRows);
        } catch (error) {
            console.error('Error handling input change:', error);
        }
    };
    const addNewRow = () => {
        const newRow = {
            srno: '',
            itemNo: '',
            requisitionNo: '',
            itemDescription: '',
            branch: '',
            qty: '',
            uom: '',
            baseQty: '',
            convRate: '',
            baseAmount: '',
            amount: '',
            stock: '',
            bol: '',
            recordId: '',
            specification: '',
            supplierId: '',
        };
        dispatch(addRow(newRow));
        const updatedRows = [...rows, newRow];
        setItemRows(updatedRows);
        onRequisitionData(updatedRows);
        dispatch(setRows(updatedRows));
    };
    const handleRemoveRow = (index) => {
        dispatch(removeSingleRow(index));
        const updatedRows = rows
            .filter((_, i) => i !== index)
            .map((row, i) => ({
                ...row,
                srno: i + 1
            }));
        onRequisitionData(updatedRows);
        setItemRows(updatedRows)
        dispatch(setRows(updatedRows));

    };
    const updateRowsWithNewStock = async () => {
        try {
            const updatedRows = rows.map(row => ({ ...row }));

            const apiPromises = updatedRows.map(async (row, index) => {
                const queryParam = `itemNo=${row.itemNo}`;
                const response = await apiService.getApiParamater(
                    'GET_ITEM',
                    `?Warehouse=${selectedLocation.label}&${queryParam}`
                );

                if (response?.data?.statusCode === 200) {
                    const itemData = response.data.result[0];
                    updatedRows[index].stock = itemData.stock / itemData?.convToInvUOM || 0;
                    updatedRows[index].stockType = itemData.stockType || "---";
                    updatedRows[index].itemNo = itemData.itemNo;
                    updatedRows[index].itemDescription = itemData.itemDescription;
                    updatedRows[index].uom = itemData.baseUnit;
                    updatedRows[index].supplierId = itemData.supplier;
                    updatedRows[index].baseQty = parseFloat(itemData.convToInvUOM);
                } else if (response?.data?.statusCode === 204) {
                    updatedRows[index] = {
                        ...row,
                        stock: 0,
                    };
                }
            });
            await Promise.all(apiPromises);
            dispatch(setRows(updatedRows));
            setItemRows(updatedRows);
            onRequisitionData(updatedRows);
        } catch (error) {
            console.error('Error updating rows with new stock:', error);
        }
    }
    const preventNegativeSign = (e) => {
        if (e.key === "-" || e.key === "+") {
            e.preventDefault();
        }
    };

    const [columnWidths, setItemColumnWidths] = useState({
        remove: 50,
        srNo: 80,
        itemNo: 160,
        description: 200,
        specification: 300,
        qty: 100,
        uom: 200,
        inventoryQty: 200,
        balForPo: 200
    });
    const ResizableHeader = ({ column, children }) => (
        <th
            style={{
                width: `${columnWidths[column]}px`,
                minWidth: `${columnWidths[column]}px`,
                position: "relative"
            }}
        >
            {children}

            <span
                className="resize-handle"
                onMouseDown={(e) =>
                    startItemColumnResize(e, column)
                }
            />
        </th>
    );
    const startItemColumnResize = (e, column) => {
        e.preventDefault();

        const startX = e.clientX;
        const startWidth = columnWidths[column];

        const handleMouseMove = (event) => {
            const newWidth = Math.max(
                50,
                startWidth + (event.clientX - startX)
            );

            setItemColumnWidths((prev) => ({
                ...prev,
                [column]: newWidth
            }));
        };

        const handleMouseUp = () => {
            document.removeEventListener(
                "mousemove",
                handleMouseMove
            );
            document.removeEventListener(
                "mouseup",
                handleMouseUp
            );
        };

        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);
    };
    return (
        <div className='table-container p-2 mb-5' style={{ overflowX: 'auto', height: "400px" }}>
            <table>
                <thead className="dynoTable">
                    <tr>
                        <ResizableHeader column="remove">
                            <span></span>
                        </ResizableHeader>

                        <ResizableHeader column="srNo">
                            Sr no
                        </ResizableHeader>

                        <ResizableHeader column="itemNo">
                            Item No
                        </ResizableHeader>

                        <ResizableHeader column="description">
                            Description
                        </ResizableHeader>

                        <ResizableHeader column="specification">
                            Item Specs
                        </ResizableHeader>

                        <ResizableHeader column="qty">
                            Qty
                        </ResizableHeader>

                        <ResizableHeader column="uom">
                            Packing UOM
                        </ResizableHeader>

                        <ResizableHeader column="inventoryQty">
                            Inventory Qty
                        </ResizableHeader>

                        <ResizableHeader column="balForPo">
                            BalForPo
                        </ResizableHeader>
                    </tr>
                </thead>

                <tbody>
                    {Array.isArray(itemRows) && rows?.map((row, index) => (<tr key={index}>

                        {/* Remove */}
                        <td
                            className="m-0 p-0"
                            style={{
                                width: `${columnWidths.remove}px`,
                                minWidth: `${columnWidths.remove}px`,
                                border: "1px solid rgba(118, 118, 118, 0.3)"
                            }}
                        >
                            <div
                                onClick={() => handleRemoveRow(index)}
                                className="center"
                            >
                                <RxCross1 size={25} />
                            </div>
                        </td>

                        {/* Sr No */}
                        <td
                            className="m-0 p-0"
                            style={{
                                width: `${columnWidths.srNo}px`,
                                minWidth: `${columnWidths.srNo}px`
                            }}
                        >
                            <input
                                className="p-2"
                                type="text"
                                value={row?.srno}
                                disabled
                                style={{
                                    width: "100%",
                                    boxSizing: "border-box"
                                }}
                            />
                        </td>

                        {/* Item No */}
                        <td
                            className="m-0 p-0"
                            style={{
                                width: `${columnWidths.itemNo}px`,
                                minWidth: `${columnWidths.itemNo}px`
                            }}
                        >
                            {/* <Tooltip text={row?.itemNo}> */}
                            <AsyncSelect
                                cacheOptions
                                value={{
                                    value: row?.itemNo,
                                    label: row?.itemNo
                                }}
                                options={itemOptions}
                                loadOptions={loadOptions}
                                onChange={(selectedOption) =>
                                    handleInputChange(
                                        index,
                                        "itemNo",
                                        selectedOption?.label
                                    )
                                }
                                defaultOptions={itemOptions}
                                onMenuScrollToBottom={
                                    loadMoreOptions
                                }
                                styles={{
                                    ...poCompactSelectStyles("itemNo"),
                                    container: (base) => ({
                                        ...base,
                                        width: "100%"
                                    }),
                                    control: (base) => ({
                                        ...base,
                                        width: "100%",
                                        minWidth: 0
                                    })
                                }}
                                menuPortalTarget={document.body}
                                noOptionsMessage={({ inputValue }) =>
                                    inputValue.length < 3
                                        ? "Type at least 3 characters..."
                                        : "No records found"
                                }
                            />
                            {/* </Tooltip> */}
                        </td>

                        {/* Description */}
                        <td
                            className="m-0 p-0"
                            style={{
                                width: `${columnWidths.description}px`,
                                minWidth: `${columnWidths.description}px`
                            }}
                        >
                            {/* <Tooltip text={row?.itemDescription}> */}
                            <AsyncSelect
                                cacheOptions
                                value={{
                                    value: row?.itemDescription,
                                    label: row?.itemDescription
                                }}
                                options={descriptionOptions}
                                loadOptions={loadDescOptions}
                                onChange={(selectedOption) =>
                                    handleInputChange(
                                        index,
                                        "itemDescription",
                                        selectedOption?.label
                                    )
                                }
                                defaultOptions={
                                    descriptionOptions
                                }
                                onMenuScrollToBottom={
                                    loadMoreDescOptions
                                }
                                styles={{
                                    ...poCompactSelectStyles(
                                        "description"
                                    ),
                                    container: (base) => ({
                                        ...base,
                                        width: "100%"
                                    }),
                                    control: (base) => ({
                                        ...base,
                                        width: "100%",
                                        minWidth: 0
                                    })
                                }}
                                className="w-100 p-0"
                                menuPortalTarget={document.body}
                                noOptionsMessage={({ inputValue }) =>
                                    inputValue.length < 3
                                        ? "Type at least 3 characters..."
                                        : "No records found"
                                }
                            />
                            {/* </Tooltip> */}
                        </td>

                        {/* Specification */}
                        <td
                            className="m-0 p-0"
                            style={{
                                width: `${columnWidths.specification}px`,
                                minWidth: `${columnWidths.specification}px`
                            }}
                        >
                            <input
                                className="p-2"
                                type="text"
                                value={row?.specification}
                                onChange={(e) =>
                                    handleInputChange(
                                        index,
                                        "specification",
                                        e.target.value
                                    )
                                }
                                style={{
                                    width: "100%",
                                    boxSizing: "border-box"
                                }}
                            />
                        </td>

                        {/* Qty */}
                        <td
                            className="m-0 p-0"
                            style={{
                                width: `${columnWidths.qty}px`,
                                minWidth: `${columnWidths.qty}px`
                            }}
                        >
                            <input
                                className="p-2"
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={preventNegativeSign}
                                type="number"
                                value={row?.qty}
                                onChange={(e) =>
                                    handleInputChange(
                                        index,
                                        "qty",
                                        e.target.value
                                    )
                                }
                                style={{
                                    width: "100%",
                                    boxSizing: "border-box"
                                }}
                            />
                        </td>

                        {/* Packing UOM */}
                        <td
                            className="m-0 p-0"
                            style={{
                                width: `${columnWidths.uom}px`,
                                minWidth: `${columnWidths.uom}px`
                            }}
                        >
                            <input
                                className="p-2"
                                disabled
                                type="text"
                                value={row?.uom}
                                style={{
                                    width: "100%",
                                    boxSizing: "border-box"
                                }}
                            />
                        </td>

                        {/* Inventory Qty */}
                        <td
                            className="m-0 p-0"
                            style={{
                                width: `${columnWidths.inventoryQty}px`,
                                minWidth: `${columnWidths.inventoryQty}px`
                            }}
                        >
                            <input
                                className="p-2"
                                disabled
                                type="number"
                                value={row?.baseQty}
                                style={{
                                    width: "100%",
                                    boxSizing: "border-box"
                                }}
                            />
                        </td>

                        {/* BalForPo */}
                        <td
                            className="m-0 p-0"
                            style={{
                                width: `${columnWidths.balForPo}px`,
                                minWidth: `${columnWidths.balForPo}px`
                            }}
                        >
                            <input
                                className="p-2"
                                disabled
                                type="text"
                                value={row?.bol}
                                style={{
                                    width: "100%",
                                    boxSizing: "border-box"
                                }}
                            />
                        </td>

                    </tr>
                    ))}
                </tbody>
            </table>
            {itemData?.eye ? "" :
                <div className='row mt-5'>
                    <div className='col-2'>
                        <button className='mainbtn ' onClick={addNewRow}>
                            <IoAddSharp color='#fff' className='center mt-1 mx-2' /> <div>Add Item</div>
                        </button>
                    </div>
                    {/* <div className=' col-2'>
                        <button className='mainbtn ' onClick={removeLastRow}>
                            Remove
                        </button>
                    </div> */}
                </div>
            }
        </div>
    );
};

export default RequisitionGrid;